var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.cardClass() + ' markdown px-3',attrs:{"id":"panel-text"},on:{"click":_vm.handleClick}},[_c('pre',{staticClass:"mb-3",staticStyle:{"font-family":"inherit","color":"inherit"},attrs:{"wrap":""}},[_vm._v("    "),_c('mrx-translation',{attrs:{"token":_vm.markdown,"renderAsHTML":true}}),_vm._v("\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }